import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import {
  FlyoutAccountSummaryHeader,
  FlyoutFooter,
  FlyoutStatusTracker,
  FlyoutToday,
  FlyoutTrackerComponent
} from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  AnalyticsDataPopulateService,
  DeviceTypeService,
  FlyoutPositionDirective
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { FlyoutAccountSummaryHeaderFacadeService } from '../data-access/facades/account-summary-header/flyout-account-summary-header-facade.service';
import { FlyoutFooterFacadeService } from '../data-access/facades/footer/flyout-footer-facade.service';
import { FlyoutStatusTrackerFacadeService } from '../data-access/facades/status-tracker/flyout-status-tracker-facade.service';
import { FlyoutTodayFacadeService } from '../data-access/facades/today/flyout-today-facade.service';
import { FlyoutTrackerView } from '../data-access/models/interfaces/flyout-search.interfaces';
import { setTrackerErrorAnalyticsData } from '../data-access/utils/status-tracker/status-tracker.utils';

@Component({
  selector: 'idp-flyout-logged-in',
  standalone: true,
  imports: [
    CommonModule,
    FlyoutTrackerComponent,
    PushPipe,
    FlyoutPositionDirective
  ],
  providers: [],
  templateUrl: './flyout-logged-in.component.html',
  styleUrls: ['./flyout-logged-in.component.scss']
})
export class FlyoutLoggedInComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  accountSummaryHeader = inject(FlyoutAccountSummaryHeaderFacadeService);
  flyoutToday = inject(FlyoutTodayFacadeService);
  flyoutFooter = inject(FlyoutFooterFacadeService);
  flyoutStatusTracker = inject(FlyoutStatusTrackerFacadeService);
  @Input() isAlertAdvisory = false;
  analyticsService = inject(AnalyticsDataPopulateService);
  emptyAccountSummaryHeaderContentDetails: FlyoutAccountSummaryHeader =
    {} as FlyoutAccountSummaryHeader;

  emptyTodayTabContentDetails: FlyoutToday = {} as FlyoutToday;
  emptyStatusTrackerDetails: FlyoutStatusTracker = {} as FlyoutStatusTracker;
  emptyFlyoutFooterContentDetails: FlyoutFooter = {} as FlyoutFooter;
  @Output() closeEvent = new EventEmitter();

  @ViewChild('flyoutTrackerDesktop') flyoutTrackerDesktop!: ElementRef;
  @ViewChild('flyoutLoggedInMobile') flyoutTrackerMobile!: ElementRef;

  show = false;
  showModal: FlyoutTrackerView = FlyoutTrackerView.Desktop;

  constructor(private deviceTypeService: DeviceTypeService) {}

  @HostListener('window:resize') onResize() {
    if (this.show) {
      if (this.deviceTypeService.getDeviceType().isDesktop) {
        this.showModal = FlyoutTrackerView.Desktop;
        this.flyoutTrackerMobile?.nativeElement?.close();
        this.enableBodyScroll();
        this.flyoutTrackerDesktop.nativeElement.showModal();
      } else {
        this.showModal = FlyoutTrackerView.Mobile;
        this.flyoutTrackerDesktop?.nativeElement?.close();
        this.flyoutTrackerMobile.nativeElement.showModal();
        this.disableBodyScroll();
      }
    }
  }

  ngOnInit() {
    this.accountSummaryHeader.init();
    this.flyoutStatusTracker.init();
    this.flyoutToday.init();
  }

  ngAfterViewInit() {
    setTimeout(() => this.openFlyoutTracker());
  }

  ngOnDestroy() {
    this.enableBodyScroll();
  }

  openFlyoutTracker(): void {
    this.show = true;

    if (this.deviceTypeService.getDeviceType().isDesktop) {
      this.showModal = FlyoutTrackerView.Desktop;
      setTimeout(() => {
        this.flyoutTrackerDesktop?.nativeElement?.showModal();
      });
    } else {
      this.showModal = FlyoutTrackerView.Mobile;
      setTimeout(() => {
        this.flyoutTrackerMobile?.nativeElement?.showModal();
        this.disableBodyScroll();
      });
    }
  }

  private disableBodyScroll(): void {
    document.body.style.overflow = 'hidden';
  }

  private enableBodyScroll(): void {
    document.body.style.overflow = '';
  }

  closeMobileModal(): void {
    this.enableBodyScroll();
    this.closeEvent.emit();
  }

  tabClickTrack(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }

  onFooterAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }

  updateTrackerErrorAnalyticsData(errorMessage: string): void {
    setTrackerErrorAnalyticsData(errorMessage);
  }
}
